<div class="mb-6">
  <div
    class="py-6 first:pt-0 last:pb-0 border-t first:border-transparent border-gray-200"
  >
    <div class="font-syne text-2xl font-semibold mb-5">
      <span *ngIf="textDirectedToCustomer">Dine</span>
      <span *ngIf="!textDirectedToCustomer">Kundens</span> oplysninger
    </div>

    <div class="mt-2 space-y-3">
      <div class="flex items-end">
        <div class="w-full">
          <div class="flex">
            <app-input
              (ngModelChange)="this.errorInCprNumber = false"
              class="component-container"
              [(ngModel)]="ksfCustomerInfo.cprNumber"
              [errorInInput]="errorInCprNumber"
              [title]="'CPR-Nummer'"
              [infoText]="
                'Vi bruger dit CPR-nummer til at identificere dig og indhente de nødvendige oplysninger til din forsikring. Oplysningerne behandles fortroligt og i overensstemmelse med gældende GDPR-regler.'
              "
            ></app-input>
          </div>
        </div>
        <div class="ml-4">
          <button
            (click)="lookupCPR()"
            type="button"
            class="h-11 w-20 py-2 px-4 rounded-lg font-inter bg-[#072C29] whitespace-nowrap inline-flex justify-center items-center gap-x-2 text-sm border border-transparent text-white disabled:opacity-50 disabled:pointer-events-none"
          >
            <lib-loading-indicator *ngIf="cprLoading" size="5 ">
            </lib-loading-indicator>

            <p *ngIf="!cprLoading">Slå op</p>
          </button>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="w-full">
          <app-input
            (ngModelChange)="this.errorInFirstname = false"
            class="component-container"
            [(ngModel)]="ksfCustomerInfo.firstname"
            [errorInInput]="errorInFirstname"
            [title]="'Navn'"
          ></app-input>
        </div>
        <div class="w-full">
          <app-input
            (ngModelChange)="this.errorInLastname = false"
            class="component-container"
            [(ngModel)]="ksfCustomerInfo.lastname"
            [errorInInput]="errorInLastname"
            [title]="'Efternavn'"
          ></app-input>
        </div>
      </div>

      <div>
        <lib-address-input
          [addressData]="addressData"
          [searchText]="addressSearchText"
          [manual]="seachManuelAddress"
          [errorInAddress]="errorInAddress"
          [errorInCustomerStreet]="errorInCustomerStreet"
          [errorInCustomerBuildingNumber]="errorInCustomerBuildingNumber"
          [errorInCustomerDoor]="errorInCustomerDoor"
          [errorInCustomerFloor]="errorInCustomerFloor"
          [errorInCustomerCity]="errorInCustomerCity"
          [errorInCustomerAdditionalCity]="errorInCustomerAdditionalCity"
          [errorInCustomerPostCode]="errorInCustomerPostCode"
          (addressSubmitted)="setAddress($event)"
          (manualChangeEvent)="seachManuelAddress = $event"
          (manualAddressChange)="manuelAddress = $event"
          (resetErrorEvent)="errorInAddress = $event"
        ></lib-address-input>
      </div>

      <div>
        <app-input
          (ngModelChange)="this.errorInEmail = false"
          class="component-container"
          [(ngModel)]="ksfCustomerInfo.email"
          [errorInInput]="errorInEmail"
          [title]="'Email'"
        ></app-input>
      </div>

      <div>
        <app-input
          (ngModelChange)="this.errorInPhoneNumber = false"
          class="component-container"
          [(ngModel)]="ksfCustomerInfo.phoneNumber"
          [errorInInput]="errorInPhoneNumber"
          [title]="'Telefon'"
        ></app-input>
      </div>

      <button
        (click)="validateCustomerInfo()"
        type="button"
        class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
      >
        Næste
      </button>
    </div>

    <!-- End Section -->
  </div>
</div>
